const PANEL_SELECTOR = '.product-single-accordion-panel';
const CLOSING_CLASS = 'is-closing';

function getPanel(details) {
  return details.querySelector(PANEL_SELECTOR);
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function animateClose(details, panel) {
  details.classList.add(CLOSING_CLASS);

  let finished = false;

  const finishClose = () => {
    if (finished) {
      return;
    }

    finished = true;
    panel.removeEventListener('transitionend', onTransitionEnd);
    window.clearTimeout(fallbackTimer);
    details.classList.remove(CLOSING_CLASS);
    details.removeAttribute('open');
  };

  const onTransitionEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'grid-template-rows') {
      return;
    }

    finishClose();
  };

  const fallbackTimer = window.setTimeout(finishClose, 500);

  panel.addEventListener('transitionend', onTransitionEnd);
}

function initProductSingleAccordions() {
  document.querySelectorAll('.product-single-accordion').forEach((details) => {
    const summary = details.querySelector('.product-single-accordion-summary');
    const panel = getPanel(details);

    if (!summary || !panel) {
      return;
    }

    summary.addEventListener('click', (event) => {
      if (prefersReducedMotion() || !details.open) {
        return;
      }

      event.preventDefault();
      animateClose(details, panel);
    });
  });
}

export default initProductSingleAccordions;
